import React, { useState } from 'react';
import { Trash2, X, Loader2 } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

// Improved Delete Confirmation Modal
const DeleteConfirmationModal = ({
                                   isOpen,
                                   onClose,
                                   onConfirm,
                                   confirmationMessage,
                                 }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setIsLoading(true);
    setError('');
    try {
      await onConfirm();
    } catch (error) {
      setError('Failed to delete. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
      <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50"
          onClick={(e) => e.target === e.currentTarget && onClose()}
      >
        <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-xl max-w-md w-full m-4"
        >
          <div className="flex justify-between items-start mb-4">
            <div className="flex items-center space-x-2">
              <div className="p-2 bg-red-100 dark:bg-red-900/30 rounded-lg">
                <Trash2 className="w-5 h-5 text-red-600 dark:text-red-400" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                Confirm Deletion
              </h3>
            </div>
            <button
                onClick={onClose}
                className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            >
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>

          <p className="mb-6 text-sm text-gray-500 dark:text-gray-400">
            {confirmationMessage}
          </p>

          {error && (
              <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  className="mb-4 p-3 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-lg"
              >
                <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
              </motion.div>
          )}

          <div className="flex flex-col-reverse sm:flex-row sm:justify-end space-y-reverse space-y-2 sm:space-y-0 sm:space-x-2">
            <button
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200
                     bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200
                     dark:hover:bg-gray-600 focus:outline-none focus:ring-2
                     focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200"
            >
              Cancel
            </button>
            <button
                onClick={handleDelete}
                disabled={isLoading}
                className="flex items-center justify-center px-4 py-2 text-sm font-medium
                     text-white bg-red-600 rounded-lg hover:bg-red-700
                     focus:outline-none focus:ring-2 focus:ring-offset-2
                     focus:ring-red-500 transition-colors duration-200
                     disabled:opacity-50 disabled:cursor-not-allowed
                     disabled:hover:bg-red-600"
            >
              {isLoading ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    Deleting...
                  </>
              ) : (
                  <>
                    <Trash2 className="w-4 h-4 mr-2" />
                    Delete
                  </>
              )}
            </button>
          </div>
        </motion.div>
      </motion.div>
  );
};
// const DeleteConfirmationModal = ({
//   isOpen,
//   onClose,
//   onConfirm,
//   confirmationMessage,
// }) => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState('');
//   const handleDelete = async () => {
//     setIsLoading(true);
//     setError('');
//     try {
//       await onConfirm();
//     } catch (error) {
//       setError('Failed to delete series. Please try again.');
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   if (!isOpen) return null;
//   return (
//     <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
//       <div className='bg-white p-6 rounded-lg shadow-lg max-w-md w-full'>
//         <h3 className='text-xl font-semibold text-gray-900 mb-4'>
//           Confirm Deletion
//         </h3>
//         <p className='mb-4 text-sm text-gray-500'>{confirmationMessage}</p>
//         {error && <p className='text-red-500 text-sm mb-4'>{error}</p>}
//         <div className='space-y-4 mb-6'>
//           <button
//             onClick={handleDelete}
//             disabled={isLoading}
//             className='w-full flex items-center justify-center px-4 py-2 text-sm font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed'
//           >
//             <Trash2 className='w-5 h-5 mr-2' />
//             {isLoading ? 'Deleting...' : 'Delete'}
//           </button>
//         </div>
//         <div className='flex justify-end'>
//           <button
//             onClick={onClose}
//             className='flex items-center px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200'
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

export default DeleteConfirmationModal;
